import React from 'react';
import iconWC from '../../../../../../assets/icons/charts/overview/icon_word_cloud.svg';
import SVG from 'react-inlinesvg';

const IconWordCloud = () => (
    <SVG src={iconWC}  height={40}  title="Menu" style = {{ marginTop: 10}} />
);
export default IconWordCloud;

// <img style = {{height: 40, margin: 10,}} src={iconWC} alt="Logo"/> style = {{height: 40, margin: 10,